<template>
	<div class="wh">
		<div class="wh">
			<common-top :commonTopData="commonTopData"></common-top>
			<!-- <div 
			class="btnorgle" 
			@click="showS">
				<img src="../assets/img/icon_sx.svg" style="margin-right:3px;position: relative;top:1px;">
				筛选
			</div> -->
			<div class="calc205">
				<!-- <comTable :config="tableConfig"></comTable> -->
				<common-table :screenConfig="screenConfig" :tableConfig="tableConfig" :tableDatas="tableData" :tableAction="tableAction"
				 ref="Tabledd"></common-table>
			</div>
		</div>
	</div>
</template>

<script>
	import commonTop from '@/components/commonTop.vue'
	import commonTable from '@/components/commonTable.vue'
	import DataScreen from "@/assets/DataScreen.js"
	import comTable from '@/components/comTable.vue'
	
	export default {
		components: {
			commonTop,
			commonTable,
			comTable
		},
		props: {},
		data() {
			return {
				// tableConfig:{
				// 	url:'userList',
				// 	list:[
				// 		{prop:'open_id',lable:'用户ID',width:150},
				// 		{prop:'avatar',lable:'头像',type:"img"},
				// 		{prop:'username',lable:'昵称', width: 160},
				// 		{prop:'mobile',lable:'视频流收藏数', width: 140},		
				// 		{prop:'video_collection',lable:'手机号', width: 140},										
				// 		{prop:'create_at',lable:'注册时间', width: 180},
				// 	],
				// 	getUrlPr:this.initPr
				// },
				commonTopData: {
					"pageName": "item0Filter",
					"commonleftbtn": [{
						name: "筛选",
						id: "left1",
						url: ""
					}],
					"commonrightbtn":[
						{name:'返回',val:'',id:'right1'}
					]

				},
				screenConfig: [],
				tableConfig: {
					total: 0,
					currentpage:1,
					pagesize:10,
					pageName:"labels",
					list: DataScreen.screenShow.item0Label.bts,
					ischeck:false
				},
				tableData: [],
				tableAction: DataScreen.screenShow.labels.action,
				detailData: "",
				IsDetail: false,
				filterFields:DataScreen.screen.labels.filterFields
			}
		},
		watch: {},
		computed: {},
		methods: {
			setLoding(type){
				this.$refs.Tabledd.setLoding(type);
			},
			getData(pg) {
				// 获取子组件表格数据
				var data = {
					access_token: localStorage.getItem("access_token"),
					page: pg.pageCurrent,
					limit: pg.pageSize
				}
				// 获取筛选的条件
				if (this.$route.query.urlDate) {
					const sreenData = JSON.parse(this.$route.query.urlDate);
					sreenData.create_at_start= sreenData.create_time_start;
					sreenData.create_at_end= sreenData.create_time_end;
					delete sreenData.create_time_start;
					delete sreenData.create_time_end;
					sreenData.page = pg.pageCurrent;
					sreenData.limit = pg.pageSize;
					sreenData.access_token = localStorage.getItem("access_token");
					data = sreenData;
				}

				this.api.userList(data).then((da) => {
					this.tableData = da.data;
					this.tableConfig.total = da.total;
					this.tableConfig.currentpage = da.page;
					this.tableConfig.pagesize = da.page_size;
					this.setLoding(false);
				}).catch(() => {
					this.setLoding(false);
				});
			},
			screenreach() {
				eventBus.$on("sreenData", (data) => {
					this.getcommonrightbtn();
					this.getData({pageCurrent:1,pageSize:10});

				})
			},
			getcommonrightbtn(){
				this.commonTopData.commonbottombtn = [];
				if(this.$route.query.urlDate){
					const urldata = JSON.parse(this.$route.query.urlDate);
					this.filterFields.forEach(item=>{
						if(urldata[item.id]){
							var val = urldata[item.id];
							if(item.child){
								val = "";
								item.child.forEach(citem=>{
									if(citem.id == urldata[item.id]){
										val = citem.name;
									}
								})
							}
							this.commonTopData.commonbottombtn.push({btnName:item.name,val:val,id:item.id});
						}
						if(item.type == "two"){
							if(item.child){
								item.child.forEach(citem=>{
									if(urldata[citem.id]){
										this.commonTopData.commonbottombtn.push({btnName:citem.name,val:urldata[citem.id],id:citem.id})
									}
								})
							}
						}
						if(item.type == "time"){
							if(item.child){
								item.child.forEach(citem=>{
									if(urldata[citem.id]){
										this.commonTopData.commonbottombtn.push({btnName:citem.name,val:urldata[citem.id],id:citem.id})
									}
								})
							}
						}
					})
				}
			},
			resetSave(tag){
				if(this.$route.query.urlDate){
					const urldata = JSON.parse(this.$route.query.urlDate)
					delete urldata[tag];
					this.$router.push({path:'/workManager/labels',query:{urlDate:JSON.stringify(urldata)}});
				}
			},
			initPr(){
				let data = {};
				if (this.$route.query.urlDate) {
					const sreenData = JSON.parse(this.$route.query.urlDate);
					sreenData.create_at_start= sreenData.create_time_start;
					sreenData.create_at_end= sreenData.create_time_end;
					delete sreenData.create_time_start;
					delete sreenData.create_time_end;
					sreenData.page = pg.pageCurrent;
					sreenData.limit = pg.pageSize;
					sreenData.access_token = localStorage.getItem("access_token");
					data = sreenData;
				}
				return data;

			}
		},
		created() {
			this.screenreach();
			this.getcommonrightbtn();
		},
		mounted() {
			this.getData({pageCurrent:1,pageSize:50});

		},
		watch:{
			"$route":function(){
				this.screenreach();
				this.getcommonrightbtn();
				this.getData({pageCurrent:1,pageSize:50});
			}
		}
	}
</script>
